import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';


export enum AlertTypes{
    Info = 'info',
    Warning = 'warning',
    Success = 'success',
    Error = 'error',
    Stopped = 'error'
}

export const alertsArr = [
    { message: _SYSTEM_TITLES.dataCollectionMessage,
        type: AlertTypes.Info
    },
    { message: _SYSTEM_TITLES.readyForRefinementMessage,
        type: AlertTypes.Warning
    },
    { message: _SYSTEM_TITLES.refinementCompletedMessage,
        type: AlertTypes.Info
    },
    { message: _SYSTEM_TITLES.readyForTrainingMessage,
        type: AlertTypes.Info
    },
    { message: _SYSTEM_TITLES.trainingInProgressMessage,
        type: AlertTypes.Info
    },
    {
        message: _SYSTEM_TITLES.trainingCompletedMessage,
        type: AlertTypes.Info
    },
    { message: _SYSTEM_TITLES.projectStoppedMessage,
        type: AlertTypes.Stopped
    },
    { message: _SYSTEM_TITLES.projectErrorMessage,
        type: AlertTypes.Error
    }
];
